import swal from "sweetalert";
import { https } from "../http";
import store from "../store";
import {
  setStaff,
  setAttendanceStaff,
  setLoading,
  setAddStaffLoading,
  setAllStaff,
  setStaffCounts,
  setFacilityClients,
  setFacilityClientsCount,
  setloadingFacilityClients,
  setSingleStaff,
  setActiveStaffCount,
  setAllStaffWithSignature,
} from "../store/reducers/staff";
import { showError } from "../utils/index";
import { getDashboardCounts } from "./dashboard";

// GET
const getAllStaff = async (page, showLoading = true, selectedTab, search) => {
  try {
    const strUrl = `/staff/${page}?search=${search}`;
    let baseURL =
      selectedTab != undefined ? `${strUrl}&status=${selectedTab}` : strUrl;
    if (showLoading) store.dispatch(setLoading(true));
    let response = await https().get(baseURL);
    if (response?.status === 200) {
      store.dispatch(setStaff(response?.data?.staffs));
      store.dispatch(setStaffCounts(response?.data?.count));
      store.dispatch(setAllStaff(response?.data?.allStaff));
      store.dispatch(setActiveStaffCount(response?.data?.activeStaffCount));
      await getDashboardCounts();
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// GET SINGLE STAFF BY ID
const getStaffById = async (id) => {
  try {
    let baseURL = `/staff/staff/${id}`;
    let response = await https().get(baseURL);
    if (response?.status === 200) {
      store.dispatch(setSingleStaff(response?.data?.staff));
      return response?.data?.staff;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getAllAttendenceStaff = async (page, range, search, singleId) => {
  try {
    let baseURL = `/staff/manage-attendance`;
    let response = await https().post(baseURL, {
      page,
      range,
      search,
      singleId,
    });
    if (response?.status === 200) {
      store.dispatch(setAttendanceStaff(response?.data?.staffs));
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// Same endpoint but RETURNS the records (no redux dispatch) — used by the staff
// "Submitted" tab to fetch a multi-week window without clobbering the per-week
// Time Card data in redux.
const fetchAttendanceRange = async (range, singleId) => {
  try {
    const res = await https().post(`/staff/manage-attendance`, { page: "all", range, search: "", singleId });
    return res?.data?.staffs?.attendanceStaff || res?.data?.staffs || [];
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return [];
  }
};

const getAllAttendenceOfSingleStaff = async (id, range) => {
  try {
    let baseURL = `/staff/manage-attendance`;

    let response = await https().post(baseURL, { id, range });
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const updateAttendenceStaff = async (payload) => {
  try {
    let baseURL = `/staff/update-attendance`;
    let response = await https().post(baseURL, payload);
    if (response?.status === 200) {
    }
  } catch (error) {
    store.dispatch(setLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const deleteAttendanceStaff = async (id) => {
  try {
    let response = await https().post("/staff/delete-attendance", { id });
    if (response?.status === 200) {
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getFacilityClients = async (
  facilityIds = [],
  staffId,
  currentPage,
  search,
  showLoading = true,
) => {
  const dispatch = store.dispatch;
  let strUrl = "/client/facility-clients";

  try {
    if (staffId) {
      strUrl += `?staffId=${staffId}`;
    }
    if (showLoading) {
      dispatch(setloadingFacilityClients(true));
    }
    const response = await https().post(strUrl, {
      facilityIds,
      currentPage,
      search,
    });
    if (response?.status === 200) {
      dispatch(setFacilityClients(response.data.result));
      dispatch(setFacilityClientsCount(response.data.count));
    }
  } catch (error) {
    showError(
      error?.response?.data?.message || error.message,
      error?.response?.status,
    );
  } finally {
    if (showLoading) {
      dispatch(setloadingFacilityClients(false));
    }
  }
};

const uploadStaffProfile = async (data) => {
  try {
    let response = await https().post(`/staff/profilephoto`, data);

    if (response?.status === 200) {
      //getProfile();
      return response?.data;
    }
  } catch (error) {
    let _error = error?.response?.data?.message;
    showError(_error, error?.response?.status);
    return false;
  }
};

const updateAssignedStaffPatients = async (data) => {
  try {
    // store.dispatch(ssetLoading(true));
    let response = await https().post("/client/assign-staff-clients", data);

    if (response?.status === 200) {
      // swal({
      //   title: `Client Assigned Successfully`,
      //   text: "Client assigned to this Staff successfully",
      //   icon: "success",
      //   dangerMode: false,
      // });
    }
  } catch (error) {
    // store.dispatch(setLoading(false));
    showError(
      error?.response?.data?.message || error.message,
      error?.response?.status,
    );
  }
};

// // GET Facility Clients
// const getFacilityClients = async (facilityIds = [], showLoading = true) => {
//   try {
//     // if (!facilityIds || facilityIds.length === 0) throw new Error("Facility ID is required");

//     // const query = facilityIds?.map((id) => `facilityId=${id}`).join("&");
//     // const query = `facilityId=${facilityIds.join(",")}`;

//     const strUrl = `/facility-clients`;
//     if (showLoading) store.dispatch(setLoading(true));

//     let response = await https().get(strUrl, facilityIds);
//     if (response?.status === 200) {
//       store.dispatch(setFacilityClients(response?.data));
//     }
//   } catch (error) {
//     store.dispatch(setLoading(false));
//     showError(
//       error?.response?.data?.message || error.message,
//       error?.response?.status
//     );
//   }
// };

// POST
// Function to add a staff member
const addStaff = async (data, selectedTab) => {
  try {
    store.dispatch(setAddStaffLoading(true));
    if (data.email) data.email = data.email.trim().toLowerCase();
    let response = await https().post("/staff", data);

    if (response?.status === 200) {
      swal({
        title: `Successful`,
        text: response?.data?.message,
        icon: "success",
        dangerMode: false,
      });
      store.dispatch(setAddStaffLoading(false));
      getAllStaff(1, true, selectedTab, "");
      return response?.data;
    }
  } catch (error) {
    store.dispatch(setAddStaffLoading(false));

    let string = error?.response?.data?.message;
    if (string?.includes("duplicate") && string.includes("email"))
      return showError("Staff with this email already exists");
    if (string?.includes("duplicate") && string.includes("name"))
      return showError("Staff with this name already exists");
    else showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// PUT

const editStaff = async (data, showLoading = true, selectedTab) => {
  try {
    store.dispatch(setAddStaffLoading(true));
    if (data.email) data.email = data.email.trim().toLowerCase();
    let response = await https().put(`/staff`, data);
    if (response?.status === 200) {
      getAllStaff(1, true, selectedTab, "");
      return true;
    }
  } catch (error) {
    store.dispatch(setAddStaffLoading(false));
    let string = error?.response?.data?.message;
    if (string?.includes("duplicate") && string.includes("email"))
      return showError("Staff with this email already exists");
    else showError(string, error?.response?.status);
    return false;
  }
};

// update staff status

const updateStaffStatus = async (data, showLoading = true, selectedTab) => {
  const { id, active } = data;
  try {
    store.dispatch(setAddStaffLoading(true));
    let response = await https().post(`/staff/update-status/${id}`, {
      status: active,
    });
    if (response?.status === 200) {
      getAllStaff(1, true, selectedTab, "");
      return true;
    }
  } catch (error) {
    store.dispatch(setAddStaffLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};
const updateStaff = async (data, showLoading = true) => {
  const { token } = data;
  try {
    // store.dispatch(setAddStaffLoading(true));
    let response = await https().post(`/staff/business-invite`, { token }); // add missing /
    if (response?.status === 200) {
      return true;
    }
  } catch (error) {
    // store.dispatch(setAddStaffLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

// DELETE

const removeStaff = async (id, callback, selectedTab) => {
  try {
    store.dispatch(setAddStaffLoading(true));
    let response = await https().delete(`/staff/${id}`);
    if (response?.status === 200) {
      getAllStaff(1, true, selectedTab, "");
      callback?.();
    }
  } catch (error) {
    store.dispatch(setAddStaffLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const getAttendanceReport = async (filters) => {
  try {
    let response = await https().post('/staff/attendance-report', filters);
    if (response?.status === 200) {
      return response?.data?.records || [];
    }
    return [];
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return [];
  }
};

const getAllStaffWithSignature = async () => {
  try {
    let response = await https().get("/staff/all-staff/with-signature");
    if (response?.status === 200) {
      store.dispatch(setAllStaffWithSignature(response?.data?.data));
      return response?.data?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

export {
  getAllStaff,
  getStaffById,
  getAllAttendenceStaff,
  fetchAttendanceRange,
  addStaff,
  removeStaff,
  editStaff,
  updateStaffStatus,
  getFacilityClients,
  updateAssignedStaffPatients,
  uploadStaffProfile,
  updateAttendenceStaff,
  deleteAttendanceStaff,
  getAllAttendenceOfSingleStaff,
  updateStaff,
  getAllStaffWithSignature,
  getAttendanceReport,
};
